/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeurekaHostNameCredentialData
 */
export interface HeurekaHostNameCredentialData {
    /**
     * 
     * @type {string}
     * @memberof HeurekaHostNameCredentialData
     */
    hostName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HeurekaHostNameCredentialData
     */
    apiKeyConfigured?: boolean;
}

/**
 * Check if a given object implements the HeurekaHostNameCredentialData interface.
 */
export function instanceOfHeurekaHostNameCredentialData(value: object): value is HeurekaHostNameCredentialData {
    return true;
}

export function HeurekaHostNameCredentialDataFromJSON(json: any): HeurekaHostNameCredentialData {
    return HeurekaHostNameCredentialDataFromJSONTyped(json, false);
}

export function HeurekaHostNameCredentialDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeurekaHostNameCredentialData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'apiKeyConfigured': json['apiKeyConfigured'] == null ? undefined : json['apiKeyConfigured'],
    };
}

export function HeurekaHostNameCredentialDataToJSON(json: any): HeurekaHostNameCredentialData {
    return HeurekaHostNameCredentialDataToJSONTyped(json, false);
}

export function HeurekaHostNameCredentialDataToJSONTyped(value?: HeurekaHostNameCredentialData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'apiKeyConfigured': value['apiKeyConfigured'],
    };
}

